import axios from 'axios';

import config from '../config';
import Category from '../features/CreateLead/interfaces/Category';
import User from '../interfaces/User';
import { BusinessLeadStatus } from '../interfaces/Lead';

const { apiServerUrl, ruleServerUrl } = config;

export const getLeadSources = (businessUnitId: number) => {
  return axios
    .get<string[]>(
      `${apiServerUrl}/users/walk-in-interest/businessUnit/${businessUnitId}/lead-sources`
    )
    .then((res) => res.data);
};

export const getLeadOwners = (businessUnitId: number, storeName?: string) => {
  const params: Record<string, string> = {};
  if (storeName) {
    params.storeName = storeName;
  }

  return axios
    .get<User[]>(
      `${apiServerUrl}/users/walk-in-interest/businessUnit/${businessUnitId}/lead-users`,
      { params }
    )
    .then((res) => res.data);
};

export const getLeadCategories = (
  businessUnitId: number,
  hierarchies: { key: string; value: string }[]
): Promise<string[][]> => {
  const data = transformWithFilters(hierarchies).map(({ field, filter }) => {
    return getCategory(businessUnitId, field, filter);
  });

  return Promise.all(data).then((res) =>
    res.reduce((acc, val) => {
      acc.push(val.values);
      return acc;
    }, [] as string[][])
  );
};

function transformWithFilters(
  items: { key: string; value: string }[]
): { field: string; filter: Record<string, string> }[] {
  const accumulatedFilters: Record<string, string> = {};
  return items.map(({ key, value }) => {
    accumulatedFilters[key] = value;
    const currentFilters = { ...accumulatedFilters };
    return {
      field: key,
      filter: currentFilters,
    };
  });
}

export const getCategory = (
  businessUnitId: number,
  field: string,
  filterJson: Record<string, any> = {}
) => {

  const filter: Record<string, string[]> = Object.fromEntries(
    Object.entries(filterJson).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.map(String) : [String(value)],
    ])
  );

  const data = encodeURIComponent(JSON.stringify(filter));

  return axios
    .get<Category>(
      `${ruleServerUrl}/users/casa-product-master/tenantBrandBusiness/${businessUnitId}/field/${field}?filterJson=${data}&isRestrictionEnabled=true`
    )
    .then(({ data }) => data);
};

export const getBusinessLeadStatuses = async (
  tenantBrandBusinessId: number
): Promise<BusinessLeadStatus[]> => {
  return axios
    .get(`${config.apiServerUrl}/users/lead-status/businessUnit/${tenantBrandBusinessId}`)
    .then((res) => res.data)
    .catch((err) => {
      throw new Error(err);
    });
};
